import { useState, useEffect } from "react"
import axios from "axios"
import _ from "lodash"
import { Field, useFormikContext } from "formik"

//styling
import styles from "../../../styles/Form.module.css"
import partnerStyles from "../../../styles/referrals/ReferralIdentityId.module.css"

//PrimeReact
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"

// Context
import { UserContext } from "../../../context/userContext"

//formik..
import { useField } from "formik"

//Referral Entity
import ReferralEntitySearch from "../../../pages/Partner/Components/EntitySearch/index"
import { useQuery } from "@apollo/client"
import { GET_ORGANIZATION_ADDRESS } from "../../../pages/Partner/Components/queries"
import { useContext } from "react"
import { FormContext } from "../../../context/formContext"
import { referralsUrl } from "../../../config/microservicesUrls"

const api_url = referralsUrl()

export default function ReferralIdentityId({ field, block, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  const isDisabled =
    field.read_only ||
    (form ? form.blocksSaved?.[block] : false)

  const [, , refEntityCountryHelpers] = useField("referral_country")
  const [, , refEntityAddressHelpers] = useField("referral_address")
  const [, , refEntityCityHelpers] = useField("referral_city")
  const [, , refEntityRefStateHelpers] = useField("referral_state")
  const [, , refEntityZipCodeHelpers] = useField("referral_zip_code")
  const [, , refEntityPhoneHelpers] = useField("referral_phone")

  const [, , refEntityIdhelpers] = useField("referral_entity_id")

  const [refEntityNameField, , refEntityNameHelpers] = useField(
    "referral_entity_name"
  )

  const [, , refEntityLocationIdHelpers] = useField("referral_location_id")
  const [refEntityTaxonomy, , refEntityTaxonomyHelpers] = useField(
    "referral_taxonomy_service"
  )
  const [refEntityTaxonomyOther, , refEntityTaxonomyOtherHelpers] = useField(
    "referral_taxonomy_service_other"
  )

  const [refTypeField] = useField("referral_type")

  const [referralEntityId, setReferralEntityId] = useState(null)
  const [showSearch, setShowSearch] = useState(false)
  const [selectedEntity, setSelectedEntity] = useState(undefined)
  const [organizationAddress, setOrganizationAddress] = useState("")
  const [referralAddress, setReferralAddress] = useState({
    name: "Unavailable",
    city: "Unavailable",
    email: "Unavailable",
    phone: "Unavailable",
  })

  useQuery(GET_ORGANIZATION_ADDRESS, {
    variables: {
      uid: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    fetchPolicy: "network-only",
    onCompleted: (result) => {
      try {
        let address = `${!!result.organization.organization_address
          ? result.organization.organization_address + ","
          : ""
          } ${!!result.organization.organization_city
            ? result.organization.organization_city + ","
            : ""
          } ${!!result.organization.organization_state
            ? result.organization.organization_state + ","
            : ""
          } ${!!result.organization.organization_country
            ? result.organization.organization_country + ","
            : ""
          } ${!!result.organization.organization_zip_code
            ? result.organization.organization_zip_code
            : ""
          }`
          .trim()
          .replace(/,\s*$/, "")

        setOrganizationAddress(address)
      } catch (ex) {
        setOrganizationAddress("")
      }
    },
    onError: (error) => {
      setOrganizationAddress("")
    },
  })

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const referralEntityId = formik?.getFieldProps("referral_entity_id")
    const referralLocationId = formik?.getFieldProps("referral_location_id")

    const fetchData = async () => {
      const url = `${api_url}/ReferralEntities/${referralEntityId.value}`
      const config = {
        headers: { Authorization: `Bearer ${userCtx.token}` },
      }

      const referrals = await axios.get(url, config)
      const values = _.map(referrals.data.referralLocations, ({ location }) => {
        if (location.id === referralLocationId.value) {
          return {
            id: location.id,
            name: location.referralEntity.name,
            city: location.city || "Unavailable",
            email: location.email,
            phone: location.phone || "Unavailable",
            entity_id: referralEntityId.value,
          }
        }
      })
      const referral = _.compact(values)
      setReferralAddress(referral[0])
    }

    if (referralEntityId?.value) {
      fetchData()
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (referralEntityId !== null) {
      formik.setFieldValue(field.field_name, referralEntityId)
    }
  }, [referralEntityId])

  function EntitySelection(entity) {
    setSelectedEntity(entity)
    setShowSearch(false)
    refEntityIdhelpers.setValue(entity.entityId)

    setReferralEntityId(entity.entityId)

    refEntityNameHelpers.setValue(entity.entityName)
    refEntityLocationIdHelpers.setValue(entity.locationId)
    refEntityCountryHelpers.setValue(entity.country)
    refEntityPhoneHelpers.setValue(entity.phone ? entity.phone : "")
    refEntityZipCodeHelpers.setValue(entity.zipcode ? entity.zipcode : "")
    refEntityRefStateHelpers.setValue(entity.state ? entity.state : "")
    refEntityCityHelpers.setValue(entity.city ? entity.city : "")
    refEntityAddressHelpers.setValue(entity.address ? entity.address : "")
    refEntityTaxonomyHelpers.setValue(entity.referralCategory || "")
    refEntityTaxonomyOtherHelpers.setValue(entity.referralCategoryOther || "")
  }

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  const isRequired = checkIfRequired()

  return (
    <>
      <div className={styles.field} style={{ order: index }}>
        <Dialog
          header={"Referral partner search"}
          visible={showSearch}
          onHide={() => {
            setShowSearch(false)
          }}
          style={{ width: "1300px", height: "771px", minWidth: "1233px" }}
        >
          <ReferralEntitySearch
            isPopup={true}
            defaultCategory={refTypeField.value}
            address={organizationAddress}
            onEntitySelect={EntitySelection}
          />
        </Dialog>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form }) => (
            <>
              <label className={styles.label}>
                {field.field_label}
                {isRequired && <span className={styles.asterisk}> *</span>}
              </label>
              <Button
                type="button"
                label="Find referral partner"
                disabled={isDisabled}
                onClick={() => {
                  if (isDisabled) return
                  setShowSearch(true)
                }}
              />
              <input
                type="hidden"
                name={field.field_name}
                value={formik.values[field.field_name]}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>

        <div className={partnerStyles.partnerGrid}>
          <div className={partnerStyles.partnerGridAreaNameTitle}>Name:</div>
          <div className={partnerStyles.partnerGridAreaName}>
            {selectedEntity && refEntityNameField.value
              ? refEntityNameField.value
              : referralAddress?.name}
          </div>
          <div className={partnerStyles.partnerGridAreaCityTitle}>City:</div>
          <div className={partnerStyles.partnerGridAreaCity}>
            {selectedEntity && selectedEntity.city
              ? selectedEntity.city
              : referralAddress?.city}
          </div>
          <div className={partnerStyles.partnerGridAreaPhoneTitle}>Phone:</div>
          <div className={partnerStyles.partnerGridAreaPhone}>
            {selectedEntity && selectedEntity.phone
              ? selectedEntity.phone
              : referralAddress?.phone}
          </div>
          <div className={partnerStyles.partnerGridAreaEmailTitle}>E-mail:</div>
          <div className={partnerStyles.partnerGridAreaEmail}>
            {selectedEntity && selectedEntity.email
              ? selectedEntity.email
              : referralAddress?.email}
          </div>
        </div>
      </div>
      <div className={styles.field}>
        <div>
          <label className={styles.label}>Referral Service</label>
        </div>
        <div className={partnerStyles.serviceGrid}>
          <div className={partnerStyles.partnerGridAreaServiceTitle}>
            Service:
          </div>
          <div className={partnerStyles.partnerGridAreaService}>
            {refEntityTaxonomy.value || "Unavailable"}
          </div>
          {refEntityTaxonomy.value?.toLowerCase().includes("other") ||
            !!refEntityTaxonomyOther.value ? (
            <>
              <div className={partnerStyles.partnerGridAreaOtherTitle}>
                Service other:{" "}
              </div>
              <div className={partnerStyles.partnerGridAreaOther}>
                {refEntityTaxonomyOther.value || "Unavailable"}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  )
}
